export const defaultCompaniesCountPerPage = 30;

export enum CompaniesSelectorFeatureEnum {
    UserManagement = 'user_management',
    ReviewSuggests = 'review_suggests',
    ReviewGptSuggests = 'review_gpt_reply_suggestions',
    ReviewsGenerator = 'reviews_generator',
    Posts = 'posts',
    Prices = 'prices',
    Omnichannel = 'omnichannel',
    CompaniesExport = 'companies_export',
    LocalPack = 'local_pack',
    YandexStories = 'stories',
    SourceSettingsAccounts = 'source_settings_accounts',
    ReviewsWidget = 'reviews_widget',
}
